import React from 'react';
import { Table } from 'react-bootstrap';

const MostViewedPagesTable = ({ mostViewedPages = [] }) => {
  const headerStyle = {
    backgroundColor: '#E8F5E9',
    color: '#1B5E20',
    fontWeight: 'bold',
    padding: '8px 12px',
    fontSize: '13px',
  };

  const viewsStyle = {
    color: '#1B5E20',
    fontWeight: '500',
  };

  const cellStyle = {
    padding: '8px 12px',
    fontSize: '13px',
    border: 'none',
  };

  const pagesData = mostViewedPages.slice(0, 5).map((item) => ({
    pageName: item.PageName,
    views: item.TotalViewCount,
  }));

  return (
    <div className="col-12 col-md-6 col-xl-3">
      <div className="card h-100">
        <div className="card-body p-3">
          <h6
            className="text-lg mb-3"
            style={{
              color: '#1B5E20',
              fontWeight: 'bold',
              fontSize: '14px',
            }}
          >
            Most Viewed Pages
          </h6>

          <div
            style={{
              border: '1px solid #C8E6C9',
              borderRadius: '5px',
              overflow: 'hidden',
            }}
          >
            <Table responsive hover className="mb-0" style={{ margin: '0' }}>
              <thead>
                <tr>
                  <th style={{ ...headerStyle, width: '70%' }}>Page Name</th>
                  <th className="text-end" style={{ ...headerStyle, width: '30%' }}>
                    Views
                  </th>
                </tr>
              </thead>

              <tbody>
                {pagesData.map((item, index) => (
                  <tr key={index}>
                    <td style={{ ...cellStyle, whiteSpace: 'nowrap' }}>
                      <span
                        style={{
                          display: 'inline-block',
                          maxWidth: '100%',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }}
                      >
                        {item.pageName}
                      </span>
                    </td>
                    <td className="text-end" style={{ ...cellStyle, ...viewsStyle }}>
                      {item.views}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MostViewedPagesTable;
